import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosTrainings from '../../config/axios_trainings';



//SLUGIFY (https://mhagemann.medium.com/the-ultimate-way-to-slugify-a-url-string-in-javascript-b8e4a0d849e1)
function slugify(string) {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

const showToastCreateTraining = () => {
        toast('Nouvelle formation crée', {
            position: toast.POSITION.TOP_CENTER
        });
    };

const showToastCreateTrainingError = () => {
        toast.error('Echec de la création, cette formation existe peut-être déjà', {
            position: toast.POSITION.TOP_CENTER
        });
    };
const showToastUpdateTraining = () => {
        toast('Formation modifiée', {
            position: toast.POSITION.TOP_CENTER
        });
    };

const showToastUpdateTrainingError = () => {
        toast.error('Echec de la modification', {
            position: toast.POSITION.TOP_CENTER
        });
    };


//GET PRESIGNED URL
export const getTrainingPresignedUpload = (file) => async () => {
    const accessToken = localStorage.getItem('access');

    if (!accessToken) {
        throw new Error("Not authenticated");
    }

    const config = {
        headers: {
            'Authorization': `JWT ${accessToken}`,
            'Accept': 'application/json'
        }
    };

    const body = {
        file_name: file.name,
        content_type: file.type,
    };

    const res = await axiosTrainings.post(
        'admin/presigned-upload/',
        body,
        config
    );

    return res.data;
};


//UPLOAD FILE TO S3
export const uploadFileToS3 = async (file, presignedData) => {
    const { url, fields } = presignedData;

    const formData = new FormData();

    Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
    });

    formData.append("file", file);

    const response = await fetch(url, {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {
        throw new Error("S3 upload failed");
    }
};



//ADMIN CREATE TRAINING
export const create_training = (
    name,
    description,
    start_date,
    end_date,
    is_active,
    thumbnailFile
) => async dispatch => {

    try {
        // Presigned POST
        const presigned = await dispatch(
            getTrainingPresignedUpload(thumbnailFile)
        );

        // Upload S3
        await uploadFileToS3(thumbnailFile, presigned);

        // URL
        const thumbnail = presigned.file_url;

        // Create training
        const accessToken = localStorage.getItem('access');

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${accessToken}`,
                'Accept': 'application/json'
            }
        };

        const body = JSON.stringify({
            name,
            description,
            start_date,
            end_date,
            is_active,
            thumbnail,
        });

        await axiosTrainings.post('admin/', body, config);

        showToastCreateTraining();

    } catch (err) {
        console.error(err);
        showToastCreateTrainingError();
    }
};


export const update_training = (
    id,
    name,
    description,
    start_date,
    end_date,
    is_active,
    thumbnailFile // File or null
) => async dispatch => {

    try {
        let thumbnail = null;

        if (thumbnailFile instanceof File) {
            const presigned = await dispatch(
                getTrainingPresignedUpload(thumbnailFile)
            );

            await uploadFileToS3(thumbnailFile, presigned);
            thumbnail = presigned.file_url;
        }

        const accessToken = localStorage.getItem('access');

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${accessToken}`,
                'Accept': 'application/json'
            }
        };

        const body = JSON.stringify({
            name,
            description,
            start_date,
            end_date,
            is_active,
            ...(thumbnail && { thumbnail }),
        });

        await axiosTrainings.patch(`admin/${id}/`, body, config);

        showToastUpdateTraining();

    } catch (err) {
        console.error(err);
        showToastUpdateTrainingError();
    }
};
